import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/instagram.svg'
import _imports_1 from '@/assets/img/facebook.svg'
import _imports_2 from '@/assets/img/vimeo.svg'
import _imports_3 from '@/assets/img/youtube.svg'
import _imports_4 from '@/assets/img/message.svg'


const _hoisted_1 = { id: "featuredArticle" }
const _hoisted_2 = { class: "img-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "sidebar desktop flex wrap" }
const _hoisted_6 = {
  key: 0,
  class: "logo box-shadow bc-blue right reversed nohover flex align-center nohover"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "sidebar mobile flex wrap" }
const _hoisted_9 = { class: "tags flex row wrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "bottom" }
const _hoisted_15 = { class: "author-date" }
const _hoisted_16 = { class: "country" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "social flex" }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "instagram"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "facebook"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "vimeo"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "youtube"
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "email"
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1)
const _hoisted_36 = { class: "right" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "content" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { key: 3 }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { key: 4 }
const _hoisted_46 = {
  key: 5,
  class: "wp-block-gallery has-nested-images columns-default is-cropped"
}
const _hoisted_47 = ["data-index", "data-video", "data-full_image", "data-caption"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["data-index", "src", "alt", "data-video"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["data-index", "src", "alt", "data-full_image", "data-caption"]
const _hoisted_52 = { key: 2 }
const _hoisted_53 = {
  key: 3,
  id: "contactForm"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "form" }
const _hoisted_57 = ["action"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "اسم")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "بريدك الإلكتروني")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Message "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "الرسالة")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn blue bc-blue border submit"
  }, [
    /*#__PURE__*/_createTextVNode("Submit "),
    /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "أرسل")
  ])
], -1)
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_Lightbox = _resolveComponent("Lightbox")

  return (_openBlock(), _createElementBlock("div", {
    id: "directoryPost",
    class: _normalizeClass(["view", {'scrolled': _ctx.scrolled}])
  }, [
    (_ctx.activePost)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["post", _ctx.activePost.custom_fields.language])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.activePost.custom_fields.banner && _ctx.activePost.custom_fields.banner.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.activePost.custom_fields.banner.url
                  }, null, 8, _hoisted_3))
                : (_ctx.activePost.custom_fields.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.activePost.custom_fields.image.url
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.activePost.custom_fields.logo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: _ctx.activePost.custom_fields.logo.sizes.medium,
                        alt: _ctx.activePost.custom_fields.logo.title
                      }, null, 8, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePost.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "filter blue fit",
                    onClick: $event => (_ctx.goToTag(tag.slug,tag.name))
                  }, _toDisplayString(tag.name), 9, _hoisted_10))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.activePost.post_title)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(_ctx.activePost.post_title), 1))
                : (_openBlock(), _createElementBlock("h3", _hoisted_13, "This article doesn't exist.")),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString((_ctx.activePost.custom_fields.country ? _ctx.activePost.custom_fields.country : '')), 1),
                  (_ctx.activePost.custom_fields.website)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("a", {
                          class: "web",
                          href: _ctx.activePost.custom_fields.website,
                          target: "_blank",
                          rel: "noopener"
                        }, _toDisplayString(_ctx.activePost.custom_fields.website), 9, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.activePost.custom_fields.instagram)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "instagram filter blue fit flex center align-center",
                      href: _ctx.activePost.custom_fields.instagram,
                      target: "_blank",
                      rel: "noopener"
                    }, _hoisted_23, 8, _hoisted_21))
                  : _createCommentVNode("", true),
                (_ctx.activePost.custom_fields.facebook)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "facebook filter blue fit flex center align-center",
                      href: _ctx.activePost.custom_fields.facebook,
                      target: "_blank",
                      rel: "noopener"
                    }, _hoisted_26, 8, _hoisted_24))
                  : _createCommentVNode("", true),
                (_ctx.activePost.custom_fields.vimeo)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      class: "vimeo filter blue fit flex center align-center",
                      href: _ctx.activePost.custom_fields.vimeo,
                      target: "_blank",
                      rel: "noopener"
                    }, _hoisted_29, 8, _hoisted_27))
                  : _createCommentVNode("", true),
                (_ctx.activePost.custom_fields.youtube)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      class: "youtube filter blue fit flex center align-center",
                      href: _ctx.activePost.custom_fields.youtube,
                      target: "_blank",
                      rel: "noopener"
                    }, _hoisted_32, 8, _hoisted_30))
                  : _createCommentVNode("", true),
                (_ctx.activePost.custom_fields.email)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      class: "email filter blue fit flex center align-center",
                      href: "",
                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.openContact(_ctx.activePost.custom_fields.email,$event)))
                    }, _hoisted_34))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", {
              class: "content description",
              innerHTML: _ctx.activePost.custom_fields.description
            }, null, 8, _hoisted_37),
            _createElementVNode("div", _hoisted_38, [
              (_ctx.activePost.custom_fields.clients)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_39, "Clients"))
                : _createCommentVNode("", true),
              (_ctx.activePost.custom_fields.clients)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: _ctx.activePost.custom_fields.clients
                  }, null, 8, _hoisted_40))
                : _createCommentVNode("", true),
              (_ctx.activePost.custom_fields.awards)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_41, "Awards"))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "awards",
                innerHTML: _ctx.activePost.custom_fields.awards
              }, null, 8, _hoisted_42),
              (_ctx.activePost.custom_fields.software)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_43, "Software"))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                innerHTML: _ctx.activePost.custom_fields.software
              }, null, 8, _hoisted_44),
              (_ctx.activePost.custom_fields.work)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_45, "Work"))
                : _createCommentVNode("", true),
              (_ctx.activePost.custom_fields.work)
                ? (_openBlock(), _createElementBlock("figure", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePost.custom_fields.work, (work, index) => {
                      return (_openBlock(), _createElementBlock("figure", {
                        class: _normalizeClass('box-shadow bc-blue wp-block-'+work.custom_fields.type+' lightgall'),
                        "data-index": index,
                        "data-video": work.custom_fields.video,
                        "data-full_image": (work.custom_fields.image && work.custom_fields.image.sizes ? work.custom_fields.image.sizes.large : work.custom_fields.image_url),
                        "data-caption": work.custom_fields.image.caption
                      }, [
                        (work.custom_fields.type == 'video')
                          ? (_openBlock(), _createElementBlock("a", _hoisted_48, [
                              _createElementVNode("img", {
                                "data-index": index,
                                src: (work.custom_fields.image && work.custom_fields.image.sizes ? work.custom_fields.image.sizes.large : work.custom_fields.image_url),
                                alt: work.post_title,
                                "data-video": work.custom_fields.video
                              }, null, 8, _hoisted_49)
                            ]))
                          : (_openBlock(), _createElementBlock("a", _hoisted_50, [
                              _createElementVNode("img", {
                                "data-index": index,
                                src: (work.custom_fields.image && work.custom_fields.image.sizes ? work.custom_fields.image.url : work.custom_fields.image_url),
                                alt: work.post_title,
                                "data-full_image": (work.custom_fields.image && work.custom_fields.image.sizes ? work.custom_fields.image.sizes.large : work.custom_fields.image_url),
                                "data-caption": work.custom_fields.image.caption
                              }, null, 8, _hoisted_51)
                            ])),
                        (work.custom_fields.image.caption)
                          ? (_openBlock(), _createElementBlock("figcaption", _hoisted_52, _toDisplayString(work.custom_fields.image.caption), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_47))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.lightboxSrc && _ctx.fullSlide[_ctx.currentIndex].custom_fields.type == 'image')
      ? (_openBlock(), _createBlock(_component_Lightbox, {
          key: 1,
          src: (_ctx.fullSlide[_ctx.currentIndex].custom_fields.image ? _ctx.fullSlide[_ctx.currentIndex].custom_fields.image.sizes.large : _ctx.fullSlide[_ctx.currentIndex].custom_fields.image_url),
          type: _ctx.fullSlide[_ctx.currentIndex].custom_fields.type,
          related: _ctx.relatedPost,
          color: '#483BFF',
          caption: _ctx.fullSlide[_ctx.currentIndex].custom_fields.image.caption,
          lang: _ctx.activePost.custom_fields.language,
          colorName: 'blue',
          totalSlide: _ctx.fullSlide.length,
          index: _ctx.currentIndex
        }, null, 8, ["src", "type", "related", "caption", "lang", "totalSlide", "index"]))
      : (_ctx.lightboxSrc && _ctx.fullSlide[_ctx.currentIndex].custom_fields.type == 'video')
        ? (_openBlock(), _createBlock(_component_Lightbox, {
            key: 2,
            src: _ctx.fullSlide[_ctx.currentIndex].custom_fields.video,
            type: _ctx.fullSlide[_ctx.currentIndex].custom_fields.type,
            related: _ctx.relatedPost,
            color: '#483BFF',
            caption: _ctx.fullSlide[_ctx.currentIndex].custom_fields.image.caption,
            lang: _ctx.activePost.custom_fields.language,
            colorName: 'blue',
            totalSlide: _ctx.fullSlide.length,
            index: _ctx.currentIndex
          }, null, 8, ["src", "type", "related", "caption", "lang", "totalSlide", "index"]))
        : _createCommentVNode("", true),
    (_ctx.contact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          _createElementVNode("div", {
            id: "overlay",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.closeContact && _ctx.closeContact(...args)))
          }),
          _createElementVNode("a", {
            href: "",
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.closeContact && _ctx.closeContact(...args))),
            class: _normalizeClass('close btn auto border bc-blue blue')
          }, _hoisted_55),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("form", {
              id: "sendEmail",
              onSubmit: _cache[6] || (_cache[6] = (...args) => (_ctx.checkForm && _ctx.checkForm(...args))),
              action: _ctx.$route.query.page,
              method: "get"
            }, [
              _hoisted_58,
              _createElementVNode("p", null, [
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.name) = $event)),
                  placeholder: ""
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ])
              ]),
              _hoisted_59,
              _createElementVNode("p", null, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.email) = $event)),
                  placeholder: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _hoisted_60,
              _withDirectives(_createElementVNode("textarea", {
                id: "message",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.message) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.message]
              ]),
              _hoisted_61,
              (_ctx.success != '')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "success",
                    innerHTML: _ctx.success
                  }, null, 8, _hoisted_62))
                : _createCommentVNode("", true),
              (_ctx.warning != '')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "warning",
                    innerHTML: _ctx.warning
                  }, null, 8, _hoisted_63))
                : _createCommentVNode("", true)
            ], 40, _hoisted_57)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}